import { useEffect, useState } from 'react';
import { collection, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useAuth } from '../contexts/AuthContext';

export function useHistorico(projetos) {
  const { usuario } = useAuth();
  const [rawHistorico, setRawHistorico] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [carregando, setCarregando] = useState(true);

  // Assinatura única — busca todos os registros do historico
  useEffect(() => {
    if (!usuario?.uid) return;

    const q = query(
      collection(db, 'historico'),
      orderBy('concluidaEm', 'desc'),
      limit(500)
    );

    const unsub = onSnapshot(q, (snap) => {
      setRawHistorico(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setCarregando(false);
    });

    return unsub;
  }, [usuario?.uid]);

  // Filtra pelos projetos acessíveis pelo usuário atual (próprios + convidado)
  useEffect(() => {
    const projetoIds = new Set(projetos.map((p) => p.id));
    const projetoMap = new Map(projetos.map((p) => [p.id, p]));

    const filtrado = rawHistorico
      .filter((r) => projetoIds.has(r.projetoId))
      .map((r) => ({
        ...r,
        projetoNome: projetoMap.get(r.projetoId)?.nome ?? r.projetoId,
      }));

    setHistorico(filtrado);
  }, [rawHistorico, projetos]);

  return { historico, carregando };
}
